import React, { createContext, useContext, useEffect, useState } from 'react';

const LANGUAGE_STORAGE_KEY = 'goplay-language';
const LanguageContext = createContext(null);

export const SUPPORTED_LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
];

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'fr');

  useEffect(() => {
    const supported = SUPPORTED_LANGUAGES.some(({ code }) => code === language);
    const nextLanguage = supported ? language : 'fr';
    document.documentElement.lang = nextLanguage;
    document.documentElement.dir = nextLanguage === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, supportedLanguages: SUPPORTED_LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
}
